"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionIssue = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const react_1 = __importStar(require("react"));
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
const IssueForm_1 = __importDefault(require("../../OpPerformQuestionCard/IssueForm"));
const IssueLinkCard_1 = __importDefault(require("../../OpPerformQuestionCard/IssueLinkCard"));
function OpPerformQuestionIssue(props) {
    const { answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const handleChangeAnswer = (0, react_1.useCallback)(issue => {
        var _a;
        if (!issue.title)
            issue.title = lib_i18n_1.default.t('empty-issue-title');
        if (issue) {
            doChangeAnswer({ value: issue.title, issue, photos: (_a = issue.photos) === null || _a === void 0 ? void 0 : _a.join(',') });
        }
        else {
            doChangeAnswer({ value: null, issue: null });
        }
    }, [doChangeAnswer]);
    return (react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({}, props, { hideButtonPane: true }),
        !!viewMode && react_1.default.createElement(IssueLinkCard_1.default, { answer: answer }),
        !viewMode && react_1.default.createElement(IssueForm_1.default, { onChange: handleChangeAnswer })));
}
exports.OpPerformQuestionIssue = OpPerformQuestionIssue;
exports.default = OpPerformQuestionIssue;
